import { render, staticRenderFns } from "./Stats.vue?vue&type=template&id=bfc12722&lang=pug&"
import script from "./Stats.vue?vue&type=script&lang=ts&"
export * from "./Stats.vue?vue&type=script&lang=ts&"
import style0 from "./Stats.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports